var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$route.path === '/login' && !_vm.isMobileDevice)?_c('IBAsideAuth',{attrs:{"contact":_vm.contact}}):_vm._e(),(!_vm.isMobileDevice)?_c('IBHeaderAuth',{attrs:{"contact":_vm.contact}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }